/* eslint-disable no-unused-vars */
import React from "react";
import { Container } from "react-bootstrap";
import {
  SupportForm,
  AuthLogo,
} from 'components'

/**
 * Support component for the admin dashboard.
 *
 * @param {Array} routes - Array of route objects for generating the Support menu.
 * @param {Function} menuToggle - Function to toggle the visibility of the main menu.
 * @returns {JSX.Element} - Support component JSX element.
 */
function Support({
  handleSupport = () => { },
  loading = false,
}) {

  return <>
    <main className="supportPage">
      <div className="text-cent er py-3">
        <AuthLogo width={100} />
      </div>
      <Container>
        <div className="supportPage_wrap bg-white p-3 min-vh-100">
          <section className="supoortForm ">
            <h1 className="supportPage_title mb-2">Support</h1>
            <SupportForm
              onSubmit={handleSupport}
              loading={loading}
            />
            {/* <Form>
              <Row>
                <Col sm={6}>
                  <Form.Group className="mb-3" >
                    <Form.Label>Name</Form.Label>
                    <Form.Control type="text" placeholder="Enter name" />
                  </Form.Group>
                </Col>
                <Col sm={6}>
                  <Form.Group className="mb-3" >
                    <Form.Label>Email address</Form.Label>
                    <Form.Control type="email" placeholder="Enter email" />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Description</Form.Label>
                    <Form.Control as="textarea" rows={3} />
                  </Form.Group>
                </Col>
              </Row>
              <Button variant="primary" type="submit">Submit</Button>
            </Form> */}
          </section>
          <section className="supportContent mt-4">
            <h6>Privacy Policy</h6>
            <p><b>1. Introduction</b> Welcome to CalCounts! Your privacy is important to us. This Privacy Policy outlines how we collect, use, and safeguard your personal information when you use our app.</p>
            <b>2. Information We Collect</b>
            <ul className="mb-3">
              <li>
                &nbsp;&nbsp;&nbsp;&nbsp;<b>• Personal Information:</b> Height, weight, age, weight goal, and activity type.
              </li>
              <li>
                &nbsp;&nbsp;&nbsp;&nbsp;<b>• Health Data:</b> Daily calorie intake, protein, carbohydrates, fats, water intake, steps, heart rate (via Google Fit/Health Connect).
              </li>
              <li>
                &nbsp;&nbsp;&nbsp;&nbsp;<b>• Device Data:</b> Information about your device, such as IP address and operating system.
              </li>
              <li>
                &nbsp;&nbsp;&nbsp;&nbsp;<b>• Food Data:</b> Information collected via camera scanning of food items.
              </li>
            </ul>
            <b >3. How We Use Your Information</b>
            <ul>
              <li>
                &nbsp;&nbsp;&nbsp;&nbsp;•	To calculate personalized nutrition and fitness plans.
              </li>
              <li>
                &nbsp;&nbsp;&nbsp;&nbsp;•	To sync and display health metrics from Google Fit/Health Connect.
              </li>
              <li>
                &nbsp;&nbsp;&nbsp;&nbsp;•	To improve and personalize app performance.
              </li>
              <li>
                &nbsp;&nbsp;&nbsp;&nbsp;•	To track and analyze user trends.
              </li>
            </ul>
            <br/>
            <b > 4. Data Sharing and Storage</b>
            <ul>
              <li>
                &nbsp;&nbsp;&nbsp;&nbsp;• Your data is securely stored and will not be shared with third parties without your consent.
              </li>
              <li>
                &nbsp;&nbsp;&nbsp;&nbsp;•	Data synced with Google Fit/Health Connect complies with their respective privacy policies.
              </li>
            </ul>
            <br/>
            <p><b>5. Security</b> We use industry-standard encryption and security protocols to protect your data.</p>
            <b > 6. User Rights</b>
            <ul>
              <li>
                &nbsp;&nbsp;&nbsp;&nbsp;•	Access, modify, or delete your personal data.
              </li>
              <li>
                &nbsp;&nbsp;&nbsp;&nbsp;•	Opt-out of certain data-sharing features.
              </li>
            </ul>
            <br/>
            <b > 7.  Subscription Information</b>
            <p> &nbsp;&nbsp;&nbsp;&nbsp;• CalCounts offers a <b>subscription-based service</b> with the following plans:</p>
            <b style={{
              color: '#0087ff'
            }}>1. Monthly Subscription</b>
            <ul className="mb-3">
              <li>
                &nbsp;&nbsp;&nbsp;&nbsp;<b>• Price:</b> $9.99/month
              </li>
              <li>&nbsp;&nbsp;&nbsp;&nbsp;<b>• Features:</b> Personalized calorie management, <b>diet and nutrition recommendations, progress tracking, food and exercise logging</b> (with camera and barcode scan), <b>AI-powered food recognition and nutrient extraction.</b></li>
              <li>&nbsp;&nbsp;&nbsp;&nbsp;<b>• Auto-Renewal:</b> Yes, with cancellation available via Apple ID settings. Subscription remains active until the end of the billing cycle.</li>
            </ul>
            <b style={{
              color: '#0087ff'
            }}>2. Yearly Subscription</b>
            <ul>
              <li>&nbsp;&nbsp;&nbsp;&nbsp;<b>• Price:</b> $29.99/year</li>
              <li>&nbsp;&nbsp;&nbsp;&nbsp;<b>• Free Trial:</b>  3-day trial available</li>
              <li>&nbsp;&nbsp;&nbsp;&nbsp;<b>• Features</b>: Same as Monthly Subscription</li>
              <li>&nbsp;&nbsp;&nbsp;&nbsp;<b>• Auto Renewal:</b>- Yes, with cancellation available via <b>Apple ID settings.</b> Subscription remains active until the end of the billing cycle.</li>
            </ul>
            <p><b>Note: </b>Subscriptions are billed automatically <b>unless canceled before the next billing cycle.</b> Terms, pricing, and cancellation policies are clearly communicated within the app in compliance with Apple’s guidelines.</p>
            <b >8. Changes to This Policy</b>
            <p> &nbsp;&nbsp;&nbsp;&nbsp;• We may update this Privacy Policy periodically. Users will be notified of significant changes through in-app notifications or emails.</p>
            <b >9. Contact Us</b>
            <p> &nbsp;&nbsp;&nbsp;&nbsp;• For any privacy concerns or questions, contact us at codiantapp@gmail.com.</p>

          </section>
        </div>
      </Container>
    </main>
  </>
}

export default Support;
